// extracted by mini-css-extract-plugin
export default {"colors":"\"../../../styles/variables/colors.module.css\"","color-blue300":"#516681","color-white":"#ffffff","button":"SocialNetworks_button__RxwaE"};